module.exports = __webpack_public_path__ + "static/img/RW966_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RW966_1.png
// module id = /DSk
// module chunks = 0